(function ($) {
  if (this.ys && this.ysStorage) {
    // Propagate registration to storage
    if (typeof this.skodaEventRegistration !== 'undefined') {
      this.ysStorage.Set(
        'skoda-event-registration',
        this.skodaEventRegistration
      );
    }

    // Load saved data from previous runs
    var registration = this.ysStorage.Get('skoda-event-registration');
    var $form = $('.skoda-event-registration .wpforms-form');
    if (registration && $form.length > 0) {
      var registrationKeys = Object.keys(registration);
      for (var i = 0; i <= registrationKeys.length; i++) {
        var $input = $form.find('.entry-' + registrationKeys[i]);
        var value = registration[registrationKeys[i]];

        var values;
        if (registrationKeys[i] === 'data_keep_preference') {
          values = value.split(',');
        } else {
          values = [value];
        }

        if ($input.length > 0) {
          switch (true) {
            case $input.hasClass('wpforms-field-radio'):
            case $input.hasClass('wpforms-field-checkbox'):
              $input.find('input[type=radio], input[type=checkbox]').each(
                (function ($, arr) {
                  return function (index, el) {
                    var $el = $(el);
                    $el.prop('checked', false);
                    if (arr.indexOf($el.val()) >= 0) {
                      $el.prop('checked', true);
                    }
                  };
                })($, values)
              );
              break;
            default:
              $input.find('input, select, textarea').val(value);
          }
        }
      }
    }
  }
}).bind(window)(jQuery);
